// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"279":"1d9ede6c","443":"d7610913"}[chunkId] + ".chunk.css";
};